/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { getEntities as getConsumables } from 'app/entities/consumable/consumable.reducer';
import { getEntities as getPharmacySuppliers } from 'app/entities/pharmacy-suppliers/pharmacy-suppliers.reducer';
import { getEntities as getPharmacyStockBills } from 'app/entities/pharmacy-stock-bill/pharmacy-stock-bill.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-consumable-stock.reducer';

export const PharmacyConsumableStockUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const consumables = useAppSelector(state => state.consumable.entities);
  const pharmacySuppliers = useAppSelector(state => state.pharmacySuppliers.entities);
  const pharmacyStockBills = useAppSelector(state => state.pharmacyStockBill.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const pharmacyConsumableStockEntity = useAppSelector(state => state.pharmacyConsumableStock.entity);
  const loading = useAppSelector(state => state.pharmacyConsumableStock.loading);
  const updating = useAppSelector(state => state.pharmacyConsumableStock.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyConsumableStock.updateSuccess);
  const pharmacyAddedByTypeValues = Object.keys(PharmacyAddedByType);

  const handleClose = () => {
    navigate(`/pharmacy-consumable-stock${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacies({}));
    dispatch(getConsumables({}));
    dispatch(getPharmacySuppliers({}));
    dispatch(getPharmacyStockBills({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.stockQty !== undefined && typeof values.stockQty !== 'number') {
      values.stockQty = Number(values.stockQty);
    }
    if (values.manufacDate !== undefined && typeof values.manufacDate !== 'number') {
      values.manufacDate = Number(values.manufacDate);
    }
    if (values.expDate !== undefined && typeof values.expDate !== 'number') {
      values.expDate = Number(values.expDate);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.mrp !== undefined && typeof values.mrp !== 'number') {
      values.mrp = Number(values.mrp);
    }
    if (values.price !== undefined && typeof values.price !== 'number') {
      values.price = Number(values.price);
    }
    if (values.remainingQuantity !== undefined && typeof values.remainingQuantity !== 'number') {
      values.remainingQuantity = Number(values.remainingQuantity);
    }
    if (values.packs !== undefined && typeof values.packs !== 'number') {
      values.packs = Number(values.packs);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    if (values.margin !== undefined && typeof values.margin !== 'number') {
      values.margin = Number(values.margin);
    }
    if (values.cessAmount !== undefined && typeof values.cessAmount !== 'number') {
      values.cessAmount = Number(values.cessAmount);
    }
    if (values.importDuty !== undefined && typeof values.importDuty !== 'number') {
      values.importDuty = Number(values.importDuty);
    }
    if (values.freeQty !== undefined && typeof values.freeQty !== 'number') {
      values.freeQty = Number(values.freeQty);
    }

    const entity = {
      ...pharmacyConsumableStockEntity,
      ...values,
      pharmacy: pharmacies.find(it => it.id.toString() === values.pharmacy?.toString()),
      consumable: consumables.find(it => it.id.toString() === values.consumable?.toString()),
      supplier: pharmacySuppliers.find(it => it.id.toString() === values.supplier?.toString()),
      bill: pharmacyStockBills.find(it => it.id.toString() === values.bill?.toString()),
      uqcType: clinicalDictionaries.find(it => it.id.toString() === values.uqcType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          addedByType: 'PHARMACY',
          modifiedByType: 'PHARMACY',
          ...pharmacyConsumableStockEntity,
          pharmacy: pharmacyConsumableStockEntity?.pharmacy?.id,
          consumable: pharmacyConsumableStockEntity?.consumable?.id,
          supplier: pharmacyConsumableStockEntity?.supplier?.id,
          bill: pharmacyConsumableStockEntity?.bill?.id,
          uqcType: pharmacyConsumableStockEntity?.uqcType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyConsumableStock.home.createOrEditLabel" data-cy="PharmacyConsumableStockCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.home.createOrEditLabel">
              Create or edit a PharmacyConsumableStock
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-consumable-stock-id"
                  label={translate('tinyMedicRestApp.pharmacyConsumableStock.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.brandId')}
                id="pharmacy-consumable-stock-brandId"
                name="brandId"
                data-cy="brandId"
                type="text"
                validate={{
                  maxLength: { value: 150, message: translate('entity.validation.maxlength', { max: 150 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.stockQty')}
                id="pharmacy-consumable-stock-stockQty"
                name="stockQty"
                data-cy="stockQty"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.manufacDate')}
                id="pharmacy-consumable-stock-manufacDate"
                name="manufacDate"
                data-cy="manufacDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.expDate')}
                id="pharmacy-consumable-stock-expDate"
                name="expDate"
                data-cy="expDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.timestampentry')}
                id="pharmacy-consumable-stock-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.microSec')}
                id="pharmacy-consumable-stock-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.lastupdated')}
                id="pharmacy-consumable-stock-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.active')}
                id="pharmacy-consumable-stock-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.cursor')}
                id="pharmacy-consumable-stock-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.batchNumber')}
                id="pharmacy-consumable-stock-batchNumber"
                name="batchNumber"
                data-cy="batchNumber"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <UncontrolledTooltip target="batchNumberLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.help.batchNumber" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.taxCode')}
                id="pharmacy-consumable-stock-taxCode"
                name="taxCode"
                data-cy="taxCode"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.mrp')}
                id="pharmacy-consumable-stock-mrp"
                name="mrp"
                data-cy="mrp"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.price')}
                id="pharmacy-consumable-stock-price"
                name="price"
                data-cy="price"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.remainingQuantity')}
                id="pharmacy-consumable-stock-remainingQuantity"
                name="remainingQuantity"
                data-cy="remainingQuantity"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.packs')}
                id="pharmacy-consumable-stock-packs"
                name="packs"
                data-cy="packs"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.HSNCode')}
                id="pharmacy-consumable-stock-HSNCode"
                name="HSNCode"
                data-cy="HSNCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.rack')}
                id="pharmacy-consumable-stock-rack"
                name="rack"
                data-cy="rack"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.discount')}
                id="pharmacy-consumable-stock-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.available')}
                id="pharmacy-consumable-stock-available"
                name="available"
                data-cy="available"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.internal')}
                id="pharmacy-consumable-stock-internal"
                name="internal"
                data-cy="internal"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.shipmentItemId')}
                id="pharmacy-consumable-stock-shipmentItemId"
                name="shipmentItemId"
                data-cy="shipmentItemId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.addedById')}
                id="pharmacy-consumable-stock-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.modifiedById')}
                id="pharmacy-consumable-stock-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.addedByType')}
                id="pharmacy-consumable-stock-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.modifiedByType')}
                id="pharmacy-consumable-stock-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.margin')}
                id="pharmacy-consumable-stock-margin"
                name="margin"
                data-cy="margin"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.cessAmount')}
                id="pharmacy-consumable-stock-cessAmount"
                name="cessAmount"
                data-cy="cessAmount"
                type="text"
              />
              <UncontrolledTooltip target="cessAmountLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.help.cessAmount" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.exempted')}
                id="pharmacy-consumable-stock-exempted"
                name="exempted"
                data-cy="exempted"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="exemptedLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.help.exempted" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.importDuty')}
                id="pharmacy-consumable-stock-importDuty"
                name="importDuty"
                data-cy="importDuty"
                type="text"
              />
              <UncontrolledTooltip target="importDutyLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.help.importDuty" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.freeQty')}
                id="pharmacy-consumable-stock-freeQty"
                name="freeQty"
                data-cy="freeQty"
                type="text"
              />
              <UncontrolledTooltip target="freeQtyLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.help.freeQty" />
              </UncontrolledTooltip>
              <ValidatedField
                id="pharmacy-consumable-stock-pharmacy"
                name="pharmacy"
                data-cy="pharmacy"
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.pharmacy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-consumable-stock-consumable"
                name="consumable"
                data-cy="consumable"
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.consumable')}
                type="select"
                required
              >
                <option value="" key="0" />
                {consumables
                  ? consumables.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-consumable-stock-supplier"
                name="supplier"
                data-cy="supplier"
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.supplier')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacySuppliers
                  ? pharmacySuppliers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-consumable-stock-bill"
                name="bill"
                data-cy="bill"
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.bill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyStockBills
                  ? pharmacyStockBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-consumable-stock-uqcType"
                name="uqcType"
                data-cy="uqcType"
                label={translate('tinyMedicRestApp.pharmacyConsumableStock.uqcType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-consumable-stock" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyConsumableStockUpdate;
